// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__26icy","containerItemsCenter":"Skeleton_containerItemsCenter__7focC"};